import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  reportSelect: {
    minWidth: 200
  }
})

export default useStyles
